module.exports = __webpack_public_path__ + "img/Realisme_Fra_romantikk_til_realisme1.7fd9dc70.jpg";